import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import projects from "../projects";

function OurProjects() {
  return (
    <MKBox component="section" id="projects" py={{ xs: 6, md: 10 }}>
      <Container>
        <MKBox textAlign="center" maxWidth="40rem" mx="auto" mb={6}>
          <MKTypography variant="overline" color="info" fontWeight="bold">
            Built by Halyard
          </MKTypography>
          <MKTypography component="h2" variant="h3" mt={1} mb={2}>
            Different ideas. A shared curiosity.
          </MKTypography>
          <MKTypography variant="body1" color="text">
            From the stories we share to the worlds we discover, these are the products we are
            building.
          </MKTypography>
        </MKBox>
        <Grid container spacing={3}>
          {projects.map((project) => (
            <Grid item xs={12} md={6} key={project.id}>
              <MKBox
                component="article"
                id={project.id}
                height="100%"
                display="flex"
                flexDirection="column"
                borderRadius="xl"
                p={{ xs: 3, lg: 4 }}
                sx={{
                  backgroundColor: project.background,
                  border: "1px solid",
                  borderColor: `${project.color}22`,
                  scrollMarginTop: "2rem",
                }}
              >
                <MKBox
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mb={3}
                  gap={2}
                >
                  <Icon
                    sx={{ color: project.color, fontSize: "2rem !important" }}
                    aria-hidden="true"
                  >
                    {project.icon}
                  </Icon>
                  <MKTypography variant="caption" fontWeight="bold" sx={{ color: project.color }}>
                    {project.category}
                  </MKTypography>
                </MKBox>
                <MKTypography component="h3" variant="h3" mb={1}>
                  {project.name}
                </MKTypography>
                <MKTypography
                  variant="body1"
                  fontWeight="bold"
                  mb={2}
                  sx={{ color: project.color }}
                >
                  {project.title}
                </MKTypography>
                <MKTypography variant="body2" color="text" mb={4}>
                  {project.description}
                </MKTypography>
                <MKBox mt="auto">
                  {project.href ? (
                    <MKButton
                      component="a"
                      href={project.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="white"
                    >
                      Explore {project.name}&nbsp; <Icon aria-hidden="true">north_east</Icon>
                    </MKButton>
                  ) : (
                    <MKBox display="flex" alignItems="center" flexWrap="wrap" gap={2}>
                      <MKTypography
                        variant="caption"
                        fontWeight="bold"
                        sx={{ color: project.color }}
                      >
                        {project.status}
                      </MKTypography>
                      <MKButton
                        component="a"
                        href="#contact"
                        color="white"
                        aria-label="Ask about Infinite Worlds"
                      >
                        Ask about this project
                      </MKButton>
                    </MKBox>
                  )}
                </MKBox>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default OurProjects;
